<div class="layoutBlock">
    <div class="columnFull">
        <p-panel header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets' | hisUi}}"
            [toggleable]="false">
            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.costCoverage"
                    type="checkbox" [(ngModel)]="assets.costCoverage" (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam
                label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.costCoverageAmount' | hisUi}}">
                <p-inputNumber #content mode="currency" currency="EUR" locale="de-DE"
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.costCoverageAmount"
                    [disabled]="assets.costCoverage !== true" [(ngModel)]="assets.costCoverageAmount"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <div class="clearAndSpace"></div>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.researchFundsRequested"
                    type="checkbox" [(ngModel)]="assets.researchFundsRequested"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.researchFundsApproved"
                    type="checkbox" [(ngModel)]="assets.researchFundsApproved"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam
                label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.researchFundsAmount' | hisUi}}">
                <p-inputNumber #content mode="currency" currency="EUR" locale="de-DE"
                    [disabled]="assets.researchFundsApproved !== true" [(ngModel)]="assets.researchFundsAmount"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <div class="clearAndSpace"></div>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.facultyResourcesRequested"
                    type="checkbox" [(ngModel)]="assets.facultyResourcesRequested"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.facultyResourcesApproved"
                    type="checkbox" [(ngModel)]="assets.facultyResourcesApproved"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam
                label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.facultyResourcesAmount' | hisUi}}">
                <p-inputNumber #content mode="currency" currency="EUR" locale="de-DE"
                    [disabled]="assets.facultyResourcesApproved !== true" [(ngModel)]="assets.facultyResourcesAmount"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <div class="clearAndSpace"></div>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.internationalBudget"
                    type="checkbox" [(ngModel)]="assets.internationalBudget" (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam
                label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.internationalBudgetAmount' | hisUi}}">
                <p-inputNumber #content mode="currency" currency="EUR" locale="de-DE"
                    [disabled]="assets.internationalBudget !== true" [(ngModel)]="assets.internationalBudgetAmount"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <div class="clearAndSpace"></div>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.ownProjectFunds"
                    type="checkbox" [(ngModel)]="assets.ownProjectFunds" (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam
                label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.ownProjectFundsAmount' | hisUi}}">
                <p-inputNumber #content mode="currency" currency="EUR" locale="de-DE"
                    [disabled]="assets.ownProjectFunds !== true" [(ngModel)]="assets.ownProjectFundsAmount"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <div class="clearAndSpace"></div>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.fee"
                    type="checkbox" [(ngModel)]="assets.fee" (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam
                label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets.feeAmount' | hisUi}}">
                <p-inputNumber #content mode="currency" currency="EUR" locale="de-DE" [disabled]="assets.fee !== true"
                    [(ngModel)]="assets.feeAmount" (ngModelChange)="onModelChange($event)" />
            </his-plam>
        </p-panel>
    </div>
</div>